declare global {
  interface Window {
    fbq?: ((...args: any[]) => void) & { callMethod?: (...args: any[]) => void; queue?: any[]; loaded?: boolean; version?: string; push?: unknown };
    _fbq?: unknown;
  }
}

export const META_PIXEL_ID = '28711809368507057';
export const CHECKOUT_URL = 'https://barriga-plana.impultienda.ar/checkout';

let initialized = false;

function loadPixelScript() {
  if (document.getElementById('fb-pixel-script')) return;
  const script = document.createElement('script');
  script.id = 'fb-pixel-script';
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
}

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;

  // Install the fbq queue stub synchronously (cheap, no network) so any track() calls
  // made before the real script loads are queued instead of lost.
  const n: any = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args);
    } else {
      n.queue.push(args);
    }
  };
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];

  window.fbq('init', META_PIXEL_ID);
  window.fbq('track', 'PageView');

  // Defer downloading/parsing the actual fbevents.js bundle until the page has finished
  // loading (or the browser is idle), so it never competes with the initial render/LCP.
  const deferredLoad = () => {
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(loadPixelScript, { timeout: 4000 });
    } else {
      setTimeout(loadPixelScript, 1500);
    }
  };

  if (document.readyState === 'complete') {
    deferredLoad();
  } else {
    window.addEventListener('load', deferredLoad, { once: true });
  }
}

export function trackInitiateCheckout() {
  window.fbq?.('track', 'InitiateCheckout');
}
